function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
import React, { useContext } from "react";
import cx from "classnames";
import { useUIDSeed } from "react-uid";
import { ImageContext, useAnchor } from "../../../context";
import { Body, CallToAction, GradientOverlay, Heading, Subheading } from "../../atoms";
import { ArrowRight } from "../../icons";
import { transformVideoUrl, twMerge } from "../../../utils";
import { VideoFrame } from "../../molecules";
export var CtaBanner = function(param) {
    var image = param.image, videoUrl = param.videoUrl, label = param.label, title = param.title, content = param.content, className = param.className, callToActions = param.callToActions, brandVariant = param.brandVariant, _variant = param.variant, variant = _variant === void 0 ? "default" : _variant, _overlayStyle = param.overlayStyle, overlayStyle = _overlayStyle === void 0 ? "dark" : _overlayStyle;
    var seed = useUIDSeed();
    var ImageComponent = useContext(ImageContext).ImageComponent;
    var anchor = useAnchor();
    return /*#__PURE__*/ React.createElement("section", {
        id: anchor,
        className: twMerge(className, !!anchor && "scroll-mt-24", variant === "centered" && "text-center")
    }, /*#__PURE__*/ React.createElement("div", {
        className: "isolate grid grid-cols-1"
    }, /*#__PURE__*/ React.createElement("div", {
        role: "presentation",
        className: "relative row-start-1 col-start-1"
    }, !!image && /*#__PURE__*/ React.createElement(ImageComponent, _extends({}, image, {
        objectFit: "cover",
        objectPosition: "center",
        className: "absolute top-0 left-0 w-full h-full"
    }))), /*#__PURE__*/ React.createElement("div", {
        role: "presentation",
        className: "relative row-start-1 col-start-1 pointer-events-none"
    }, !!videoUrl && /*#__PURE__*/ React.createElement(VideoFrame, {
        title: title,
        url: videoUrl,
        className: "w-full h-full hidden md:block",
        transform: transformVideoUrl
    })), /*#__PURE__*/ React.createElement("div", {
        className: "relative row-start-1 col-start-1 z-10"
    }, overlayStyle === "gradient" && /*#__PURE__*/ React.createElement(GradientOverlay, {
        className: "absolute top-0 left-0 w-full h-full"
    }), overlayStyle === "dark" && /*#__PURE__*/ React.createElement("span", {
        className: twMerge("absolute top-0 left-0 w-full h-full", image && "bg-bg-inverted/70", !image && "bg-gray-dark")
    })), /*#__PURE__*/ React.createElement("div", {
        className: "relative row-start-1 col-start-1 z-10"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "container py-9 md:py-12"
    }, !!label && /*#__PURE__*/ React.createElement(Subheading, {
        className: twMerge("text-fg-inverted mb-4", brandVariant === "primary" && "text-brand-primary-base", brandVariant === "secondary" && "text-brand-secondary-base")
    }, label), /*#__PURE__*/ React.createElement("div", {
        className: "mb-7 flex justify-center"
    }, /*#__PURE__*/ React.createElement(Heading, {
        as: "h2",
        variant: "h2",
        className: twMerge("text-fg-inverted", variant === "centered" && "max-w-[37.5rem]")
    }, title)), variant === "default" && /*#__PURE__*/ React.createElement("span", {
        role: "presentation",
        className: "block w-[6.25rem] h-1 bg-bg-offdefault"
    }), !!content && /*#__PURE__*/ React.createElement("div", {
        className: twMerge("my-7", variant === "default" && "md:ml-[33%]")
    }, /*#__PURE__*/ React.createElement(Body, {
        className: "text-fg-inverted"
    }, content)), !!(callToActions === null || callToActions === void 0 ? void 0 : callToActions.length) && /*#__PURE__*/ React.createElement("div", {
        className: twMerge(variant === "default" && "md:ml-[33%]")
    }, /*#__PURE__*/ React.createElement("div", {
        className: twMerge(cx("flex flex-wrap items-center justify-start -m-3", !content && "justify-end", variant === "centered" && "justify-center"))
    }, callToActions.map(function(action) {
        return /*#__PURE__*/ React.createElement(CallToAction, _extends({}, action, {
            key: seed(action),
            icon: /*#__PURE__*/ React.createElement(ArrowRight, null),
            brandVariant: action.brandVariant,
            className: "m-3",
            linkVariant: "big"
        }));
    })))))));
};

//# sourceMappingURL=CtaBanner.js.map